module.exports = __webpack_public_path__ + "img/material-image08.b9a5bf8c.png";